<app-nav-bar *ngIf="renderComponent()"></app-nav-bar>
<div *ngIf="loading">
    <div class="loadingSpinner">
        <div class="contenidoSpinner">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    </div>

  <router-outlet ></router-outlet>  

